import cn from 'classnames/bind';
import PropTypes from 'prop-types';

import s from './RadioButton.module.scss';

const cx = cn.bind(s);

const RadioButton = ({
  className,
  label,
  align,
  onChange,
  color,
  large,
  labelClassName,
  checked,
  disabled,
  value,
  ...attrs
}) => {
  const radioClassNames = cx('radio', { large });
  const labelClassNames = cx('label', labelClassName, { large, labelDisabled: disabled, labelStart: align === 'start' });
  const wrapperClassNames = cx(className, 'wrapper');
  const renderRadio = () => (
    <>
      <input
        checked={checked}
        value={value}
        disabled={disabled}
        type="radio"
        className={cx('inputRadio')}
        onChange={onChange}
        {...attrs}
      />
    </>
  );

  return (
    <div className={wrapperClassNames}>
      <label className={cx(labelClassNames)}>
        {renderRadio()}
        <div className={cx(radioClassNames)}/>
        <span>{label}</span>
      </label>
    </div>
  );
};

RadioButton.propTypes = {
  label: PropTypes.string,
  large: PropTypes.bool,
  checked: PropTypes.bool,
  value: PropTypes.string,
  align: PropTypes.oneOf(['start', '']),
  onChange: PropTypes.func,
};

RadioButton.defaultProps = {
  label: '',
  checked: false,
  value: '',
  align: '',
  large: false,
  onChange: () => {
  },
};

export default RadioButton;
